import { defineStore } from 'pinia'
import { getCurrentDate } from '@/utils/date'
import type { AdhocSession } from '@/models/AdhocSession.model'
import type { ReceiptSearchFormData } from '@/models/Receipt.model'
import { mapFormDataToAdhocSessionRequest } from '@/models/Receipt.model'
import { useAdhocSessionService } from '@/services/AdhocSession.service'

interface State { formData: ReceiptSearchFormData | null, results: AdhocSession[] }

export const useReceiptFormStore = defineStore('receipt.form', {
  state: (): State => ({
    formData: {
      country: undefined,
      date: getCurrentDate(),
      price: undefined,
      creditCard: undefined,
    },
    results: [],
  }),

  actions: {
    submitForm(formData: ReceiptSearchFormData) {
      this.formData = formData
    },
    async fetchResults(clientUuid: string) {
      const { getAdhocSessions } = useAdhocSessionService()
      const request = mapFormDataToAdhocSessionRequest(clientUuid, this.formData)

      this.results = await getAdhocSessions(request)
    },
  },
})
